import { some } from 'lodash';

export default {
  validate3dots(items) {
    return some(items, (item) => item.hasGuid);
  },
};
